import React, { useContext, useEffect, useRef, useState } from 'react'
import { Button, Form, Input } from 'antd'
import { MultiStepFormData } from '../../Authentication/MultiStepForm/MultiStepForm';
import { useDispatch, useSelector } from 'react-redux';
import { businessInfo } from '../../../slices/businessInfo/thunk';
import TextArea from 'antd/es/input/TextArea';
import { formatInputValue } from '../../../Services/InputFieldService';
import { PlaceholderContent } from '../../../constants/Placeholder';

const BusinessName = () => {

  const FormData = useContext(MultiStepFormData);
  const businessData = useSelector((state) => state.BusinessInfoReducer.businessInfo)
  const [businessName, setBusinessName] = useState();
  const [businessNameLength, setBusinessNameLength] = useState(0);
  const maxLength = 150;
  const dispatch = useDispatch()
  let placeholderContent = PlaceholderContent?.SIGNUP_STEPS;

  useEffect(() => {
    let name = FormData?.formData?.businessName;
    if (name) {
      FormData.setFormVerified({
        ...FormData.formVerified,
        [FormData.page]: true
      });
    }

    dispatch(businessInfo())
  }, [])
  const onChange = (e) => {
    let value = e.target.value;
    businessNameValidation(e)
    setBusinessNameLength(value?.length)
  }
  function businessNameValidation(e) {

    let inputValue = e.target.value;
    setBusinessName(e.target.value);
    FormData.setFormData({
      ...FormData.formData,
      businessName: inputValue || businessName
    });
    if (inputValue.length >= 2) {
      FormData.setFormVerified({
        ...FormData.formVerified,
        [FormData.page]: true
      });
    }
    else {
      FormData.setFormVerified({
        ...FormData.formVerified,
        [FormData.page]: false
      });
    }
  }
  const onFinish = (values) => {

  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  useEffect(() => {
    if (businessData?.old_business_name || businessData?.business_name) {
      FormData.setFormData({
        ...FormData.formData,
        businessName: businessData?.old_business_name ? businessData?.old_business_name : businessData?.business_name
      });
      setBusinessName(businessData?.old_business_name ? businessData?.old_business_name : businessData?.business_name)
    }
  }, [businessData])

  useEffect(() => {
    if (businessName) {
      setBusinessNameLength(businessName?.length)
    }
  }, [businessName])

  return (
    <>
      <div style={{ width: "100%", marginLeft: "auto", marginRight: "auto" }} className='text-center'>

        <Form className='form_body'
          onSubmit={(event) => {
            event.preventDefault();
          }}>
          <div style={{ marginLeft: "auto", marginRight: "auto", maxWidth: "509px" }}>
            <label htmlFor="" className='text_red d-block sm'>Business Name</label>
            <div className="description_wrap">
              <Form.Item style={{marginBottom: '10px'}}
              >
                <TextArea
                  className='placeholder_left text_capitalize'
                  placeholder={placeholderContent?.BusinessName}
                  style={{ margin: "10px auto", color: "#9E9E9E", textAlign: "center", boxShadow: 'none', outline: 'none' }}
                  type="text"
                  onChange={onChange}
                  value={businessName}
                  maxLength={maxLength}
                />
              </Form.Item>
              <div className="">
                {/* <span class="form_note"><span className="text_red">* </span>Enter at least 5 characters.</span> */}
                <span class={` form_note ${businessNameLength === maxLength && 'limit'}`} ><span>{businessNameLength}</span>/{maxLength}</span>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </>
  )
}

export default BusinessName